import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { rootCategories, blogCatandSub } from "../../utils/blogCategories";

import BlogsCategoryBar from "../../components/blog/BlogCategoryBar";
import BlogHeader from "../../components/blog/BlogHeader";
import BlogCard from "../../components/cards/BlogCard";
import BlogGrid from "../../components/blog/BlogsGrid";

import axios from "axios";
import urlSet from "../../utils/urls";

import SimpleLoader from "../../components/loader/SimpleLoader";
import Head from "next/head";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import blogText from "../../utils/blogText.json";
import { fetchBlogs, fetchCategoryBlogs } from "../../utils/blogsHelper";
import { Spinner } from "react-bootstrap";

const Blogs = () => {
  const limit = 6;
  const router = useRouter();
  const [page, setPage] = useState(0);
  const [categories, setCategories] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState(null);
  const params = router.query;

  const isSubCategory = params.category;
  const isReady = router.query;

  const getNextBlogs = async () => {
    try {
      let url = urlSet.get_blogApi.url + "?index=0&limit=6&minimal=true";
      if (params.search) url = url + "&searchQuery=" + params.search;
      else if (params.category && params.subcategory) {
        url =
          url +
          `&category=${params.category}&subcategory=${params.subcategory}`;
      } else if (params.category) {
        url = url + `&category=${params.category}`;
      }
      url =
        urlSet.get_blogApi.url + "?index=" + page * limit + "&limit=" + limit;
      setLoading(true);
      const res = await axios.get(encodeURI(url));
      if (page === 0) {
        setBlogs(res.data);
      } else {
        setBlogs([...blogs, ...res.data]);
      }

      setPage(page + 1);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getBlogs = async () => {
      try {
        setLoading(true);
        const data = await fetchBlogs(params);
        setBlogs(data);
        setPage(1);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    if (params.category) {
      setCategories(blogCatandSub[params.category]);
    } else {
      setCategories(rootCategories);
    }

    if (router.isReady) {
      getBlogs();
    }
  }, [params, router.isReady]);

  const categoryHandler = (id) => {
    console.log(id, params);
    if (params.subcategory) {
      router.push(`/blogs/category/${params.category}?subcategory=${id}`);
    } else {
      router.push(`/blogs/category/${id}`);
    }
  };

  const categoryResetHandler = () => {
    router.push(`/blogs`);
  };

  const blogTextHandler = () => {
    if (params.category && params.subcategory) {
      const y = blogText.filter(
        (b) =>
          b.category === params.category && b.subcategory === params.subcategory
      );
      if (y.length === 1) {
        return y[0].text;
      } else {
        const x = blogText.filter((b) => b.category === params.category);
        return x[0].text;
      }
    } else if (params.category) {
      const y = blogText.filter((b) => b.category === params.category);
      return y[0].text;
    } else {
      return "Read On";
    }
  };

  return (
    <div>
      <Head>
        <meta
          property="og:image"
          content={
            "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
          }
        />
        <title>Blogs | Success Stories, Health & Expert Tips</title>

        <meta
          name="description"
          content="Stay up-to-date with everything happening in the Optimum Wellness community as well as a curated space for promoting general health and wellbeing. Explore latest articles featuring useful guides on nutrition, fitness hacks, and more!"
        />
        <meta name="keywords" content="fitness, health, wellness" />
      </Head>

      <div
        className={`text-center fo40 fw800 mfo32 mt-4`}
        id="blogPage_heading"
        style={{ fontWeight: "800", fontSize: "2.1rem" }}
      >
        {params.category != null && params.subcategory != null
          ? params.subcategory
          : params.category != null
          ? params.category
          : "Blogs"}
      </div>
      <div className={`text-center fo20 fw600`}>
        <img
          src={
            params.category && params.subcategory
              ? encodeURI(
                  `https://assets.alanvidyushbaptist.com/icons/${params.subcategory} Purple.png`
                )
              : params.category
              ? encodeURI(
                  `https://assets.alanvidyushbaptist.com/icons/${params.category} Purple.png`
                )
              : `https://assets.alanvidyushbaptist.com/icons/Blog_Purple.png`
          }
          alt={"icon"}
          height="60px"
          width="60px"
        />
      </div>
      <div className={`text-center fo15 txtco mfo13`}>{blogTextHandler()}</div>

      <div className="dynamicPageSection">
        <section className="allBlogsSection">
          {isReady && !params.search && (
            <div>
              <div className="navbar navbar-expand-xl mt-4 p-0 blogCategoryNavbar">
                <div className="d-block d-xl-none text-white py-3 px-4 fw-600 fo-20">
                  TOPICS
                </div>
                <button
                  className="navbar-toggler collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsibleBlogCategories"
                  aria-expanded="false"
                  aria-controls="collapsibleBlogCategories"
                >
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className="fo-20 fw-600 text-white"
                  />
                </button>
                <BlogsCategoryBar
                  params={params}
                  categories={categories}
                  onClick={categoryHandler}
                  resetHandler={categoryResetHandler}
                  selected={params.subcategory || params.category}
                />
              </div>
              <BlogHeader blogs={blogs} />
            </div>
          )}

          <div className="categoryBasedBlogs">
            {blogs && blogs.length > 0 && (
              <>
                <div className="row m-0 mt-3" id="displayAllBlogs">
                  {blogs.map((blog, index) => (
                    <BlogCard blog={blog} key={"root_blogs_card_" + index} />
                  ))}
                </div>
                {loading && (
                  <div className="d-flex justify-content-center">
                    <Spinner animation="border" />
                  </div>
                )}
                <div
                  className="text-center mt-5 homeBottom"
                  id="readmorebutton"
                >
                  {limit * page <= blogs.length ? (
                    <button
                      className="btn showMoreButton"
                      onClick={getNextBlogs}
                    >
                      READ MORE
                    </button>
                  ) : (
                    <div className="fo-18 fw-600 text-center">
                      <p>Revisit us again for more!</p>
                    </div>
                  )}
                </div>
              </>
            )}

            {rootCategories.map((cat, index) => (
              <BlogGrid key={index} category={cat.name} />
            ))}

            {!loading && blogs && blogs.length <= 0 && (
              <h2 className="text-center">No Blogs Found</h2>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Blogs;
